export default "__VITE_ASSET__3ef75ffb__"